var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 91,
    viewBox: "0 0 69 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58443 31.0367L8.96033 31.2633L9.26745 32.0213L9.05086 32.694L9.61341 32.8751L9.75467 33.2237L10.1972 33.063L51.787 46.4536L9.98166 61.6299L9.66381 61.5275L9.58443 61.7741L8.96033 62.0006L9.26745 62.7586L9.05086 63.4313L9.61341 63.6124L9.75467 63.961L10.1972 63.8004L54.7955 78.1596L55.4084 76.2558L13.2646 62.6868L56.9992 46.8102L56.2048 44.8498L54.8544 45.3401L13.2646 31.9495L56.9992 16.0729L56.2048 14.1125L9.98166 30.8925L9.66381 30.7902L9.58443 31.0367Z",
    fill: "#7ABB5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 67,
    height: 89,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.6b3012eaab24d0a3b05a004c060a52be.svg";
export { ForwardRef as ReactComponent };